import { IResearchFilterState, IResearchFilterItems } from '@/creditflowresearch/domain/vo/research/IFilterContextData';

export const initialResearchState = (isTile: boolean) => ({
  totalCount: 0,
  collection: [],
  page: 1,
  perPage: isTile ? 10 : 25,
  sortBy: 'publishedAt',
  sortOrder: 'desc',
});

export const initialResearchServerSideData = (isTile: boolean) => ({
  all: {
    count: 0,
    researchCollection: initialResearchState(isTile),
  },
  byGroup: {},
});

export const RESEARCH_STORE_NAME = 'research';
export const RESEARCH_HEADER_MAPPING_NAME = 'researchBlock';

export const INITIAL_FILTER_STATE: IResearchFilterState = {
  dateFrom: null,
  dateTo: null,
  includedDocumentTypeIds: [],
  includedPseudoSectorIds: [],
  includedPublisherIds: [],
};

export const INITIAL_ITEMS: IResearchFilterItems = {
  filter: INITIAL_FILTER_STATE,
  hash: '',
};

export const QUERY_PARAMS_TO_REMOVE = ['dateFrom', 'dateTo', 'hash'];
